import { useConcatenateFilterSelection } from '../../../../components/filters/hooks/common.hook';
import { useEncodeFilters } from '../../../../components/filters/hooks/use-encode-filters.hook';
import { useFilterVariableAndCompBrandSelection } from '../../../../components/filters/hooks/use-filter-drillthrough-selection.hook';
import { useFilterPanelSelection } from '../../../../components/filters/hooks/use-filter-panel-selection.hook';
import { FilterEncoderComponentProps } from '../../../../components/filters/interfaces/filterable-component-props.interface';
/**
 * This component is responsible for gathering filter selections and then update the URL with them.
 */
export const DemandPageFilterProvider = ({
  children,
  trackRecentVisits = true,
}: FilterEncoderComponentProps) => {
  const filterSelection = useConcatenateFilterSelection(
    useFilterPanelSelection(), // Global filters
    useFilterVariableAndCompBrandSelection(), // Variable and Comp Brand filters
  );
  // Updates URL with encoded filters.
  useEncodeFilters(filterSelection, trackRecentVisits);
  return <>{children}</>;
};
